import RequestTypeChart from './RequestTypeChart';

export default RequestTypeChart;
